import React, { forwardRef } from 'react';
import MaterialTable from '@material-table/core';
import AddBox from '@mui/icons-material/AddBox';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import Search from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
import Box from '@mui/material/Box';

const icon = (Component) => forwardRef((props, ref) => <Component {...props} ref={ref}/>);
const tableIcons = {
  Add:icon(AddBox), Check:icon(Check), Clear:icon(Clear), Delete:icon(DeleteOutline),
  DetailPanel:icon(ChevronRight), Edit:icon(Edit), Export:icon(SaveAlt), Filter:icon(FilterList),
  FirstPage:icon(FirstPage), LastPage:icon(LastPage), NextPage:icon(ChevronRight),
  PreviousPage:icon(ChevronLeft), ResetSearch:icon(Clear), Search:icon(Search),
  SortArrow:icon(ArrowDownward), ThirdStateCheck:icon(Remove), ViewColumn:icon(ViewColumn),
};

export default function ETVTable({
  title,
  data = [],
  columns = [],
  search = true,
  pageSize = 10,
  selection = false,
  actions,
  onSelectionChange,
  options = {},
  embedded = false,
}) {
	const rowCount = Array.isArray(data) ? data.length : 0;
	const searchEnabled = Boolean(search) && rowCount >= 10;
	const paginationEnabled = rowCount > pageSize;
	const toolbarEnabled = Boolean(title) || searchEnabled || selection || (Array.isArray(actions) && actions.length > 0);

	return (
	<Box sx={{
	  fontFamily:'Roboto, "Helvetica Neue", Arial, sans-serif',
	  '& *':{fontFamily:'Roboto, "Helvetica Neue", Arial, sans-serif'},
	  '& .MuiToolbar-root .MuiTypography-h6':{color:'#0d47a1',fontWeight:700},
	}}>
    <MaterialTable
      icons={tableIcons}
      title={title}
      data={data}
      columns={columns}
      actions={actions || []}
      onSelectionChange={onSelectionChange}
      options={{
		filtering:false,
        selection,
        pageSize,
        pageSizeOptions:[5,10,20,50],
        actionsColumnIndex:-1,
        padding:'dense',
        tableLayout:'auto',
		headerStyle:{backgroundColor:'#e3f2fd',color:'#0d47a1',fontWeight:700,borderBottom:'2px solid #1565c0'},
        rowStyle:(_row,index)=>({backgroundColor:index%2===0?'#ffffff':'#fcfcfd'}),
        cellStyle:{color:'#273244',borderBottom:'1px solid #edf0f3',paddingTop:9,paddingBottom:9},
        ...options,
        search:searchEnabled,
        paging:paginationEnabled,
		toolbar:toolbarEnabled,
      }}
      style={embedded
        ? {border:'none',borderRadius:0,overflow:'hidden',boxShadow:'none'}
        : {border:'1px solid #e3e7eb',borderRadius:12,overflow:'hidden',boxShadow:'none'}
      }
    />
	</Box>
  );
}
